<template>
  <div class="interaction-container--flex row">
    <label class="row">
      <span class="label">{{ label }}:</span>
      <span class="active_value" v-if="activeOption">
        {{ activeOption.title }}
      </span>
      <span class="active_value" v-else>
        {{ emptyOption.label }}
      </span>
    </label>
    <div class="image_options" ref="option_container">
      <div
        v-for="option in this.options"
        :key="option.title"
        class="image_option"
        :class="{is_active: displayedOption && displayedOption.sku_code == option.sku_code }"
        @click="handleOptionClick(option)"
      >
        <div v-if="option === displayedOption" class="active_ring">
          &nbsp;
        </div>
        <div class="image_image" :title="option.title">
          <img
              :key="option.title"
              :src="option.image_url"
              :alt="option.title"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImagePicker",
  props: {
    label: {
      type: String,
    },
    optionFunction: {
      type: String,
    },
    defaultValueFunction: {
      type: String,
    },
    setFunction: {
      type: String,
    },
    emptyOptionFunction: {
      type: String,
    },
    activeOptionFunction: {
      type: String,
    },
    valueTypeFunction: {
      type: String,
    },
    windowEvent: {
      type: String,
    },
  },
  data() {
    return {
      displayedOption: this.activeOption
    };
  },
  mounted() {
    this.displayedOption = this.options.find((option) => option.sku_code == this.activeOption.sku_code);
  },
  computed: {
    options() {
      return this.$store.getters[this.optionFunction];
    },
    activeOption() {
      return this.$store.getters[this.activeOptionFunction];
    },
    defaultValue() {
      return this.$store.getters[this.defaultValueFunction];
    },
    emptyOption() {
      return this.$store.getters[this.emptyOptionFunction];
    },
    valueType() {
      return this.$store.getters[this.valueTypeFunction];
    },
  },
  methods: {
    handleOptionClick(option) {
      if (option != this.displayedOption) {
        this.displayedOption = option;
      this.$store.dispatch(this.setFunction, option);
      if (this.windowEvent) {
        window.dispatchEvent(new CustomEvent(this.windowEvent, {detail: option}));
      }
      this.$emit("option-changed");
      }
    },
  },
};
</script>

<style scoped>
  .image_options {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    row-gap: 5px;
    -moz-column-gap: 5px;
    column-gap: 5px;
    margin: 5px 0 0;
  }
  .image_option {
    position: relative;
    border: 1px solid;
    border-color: var(--modal-border-color);
    padding-bottom: 40px;
    transition: .2s ease-in;
    cursor: pointer;
  }
  .image_image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    overflow: hidden;
    background: var(--modal-image-background-color);
  }
  .image_image img {
    width: 100%;
    min-height: 150px;
    -o-object-fit: cover;
    object-fit: cover;
  }
  .active_ring {
    border: 1px solid;
    border-color: var(--border-color);
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
  }
  .active_ring::before {
    border: 1px solid var(--active-option-foreground, #fff);
    content: " ";
    top:0;
    left:0;
    position: absolute;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    z-index: 1;
  }
  .active_value {
    font-weight: 400;
  }
  @media screen and (min-width: 1180px) {
    .image_options {
      grid-template-columns: repeat(12, 1fr);
    }
  }
  .row {
    width: 100%
  }
</style>

